import request from '@/utils/request'

// 查询历史搜索列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/sku/material/item/page',
        method: 'get',
        params: query,
    })
}
// 查询历史搜索详细
export function getObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/detail?prodSkuId=' + data.prodSkuId + '&materialItemId=' + data.materialItemId,
        method: 'get',
    })
}
// 新增历史搜索
export function addObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/add',
        method: 'post',
        data: data,
    })
}
// 修改历史搜索
export function putObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/edit',
        method: 'post',
        data: data,
    })
}
// 删除历史搜索
export function delObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/delete',
        method: 'post',
        data: data,
    })
}

export function statusObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/status',
        method: 'post',
        data: data,
    })
}
